import { StyleSheet } from 'react-native';
import Theme from 'Theme/index';
import { Device } from 'DeviceUtils';
import dialogCommon from 'Theme/DialogCommon.jss';

const textCommon = {
    fontFamily: Theme.regularFont
};

const baseStyles = {
    ...dialogCommon,

    itemContainer: {
        paddingTop: 18,
        flexGrow: 0,
        width: '100%'
    },
    itemInnerContainer: {
        flexDirection: 'row',
        width: '100%'
    },
    itemButtonContainer: {
        borderWidth: 2,
        borderColor: 'white',
        borderRadius: 3,
        backgroundColor: Theme.primaryButtonBackgroundColor,
        width: 35,
        height: 35
    },
    selectedConsent: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    iconPosition: {
        width: '75%',
        height: '75%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    line: {
        marginBottom: Theme.primaryMargin
    },
    descriptionBlock: {
        maxHeight: '30%'
    },
    headerText: {
        ...dialogCommon.title,
        marginTop: dialogCommon.title.marginBottom,
        marginLeft: 8
    },
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black',
        alignSelf: 'stretch'
    },
    iconBox: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    logo: {
        alignSelf: 'flex-start',
        width: 100,
        height: 100,
        marginBottom: 40,
        borderRadius: 5
    },
    headlineText: {
        fontSize: 26
    },
    consentText: {
        ...textCommon,
        fontSize: Theme.primaryFontSize,
        color: Theme.primaryTextColor,
        justifyContent: 'center',
        paddingLeft: 15,
        flexShrink: 1
    },
    lineWrapper: {
        paddingTop: 18
    },
    textContainer: {
        flexShrink: 1
    }
};

const landscapeStyles = StyleSheet.create({
    ...baseStyles,
    window: {
        ...baseStyles.window,
        paddingHorizontal: '20%'
    },
    buttonContainer: {
        ...baseStyles.buttonContainer,
        flexDirection: 'row'
    },
    button: {
        ...baseStyles.button,
        width: '40%',
        maxWidth: '40%'
    },
    descriptionBlock: {
        maxHeight: '50%'
    }
});

if (Device.isTabletOrWeb) {
    delete baseStyles.button.width;
}

export { landscapeStyles };
export default StyleSheet.create(baseStyles);
